import React from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import Container from './Container.js';
const ComponentKeyFunction = ({
  iconName,
  state,
  description
}) => /*#__PURE__*/React.createElement("span", {
  className: "ebds-key-functions__list__item"
}, /*#__PURE__*/React.createElement("span", {
  className: `ebds-key-functions__list__item__icon -${state ?? 'default'}`
}, /*#__PURE__*/React.createElement(IconAsChunk, {
  iconName: iconName ?? 'CheckmarkFrame'
})), /*#__PURE__*/React.createElement("span", null, description));
const KeyFunctions = ({
  headline,
  subheadline = '',
  description = '',
  imgUrl = '',
  imgAlt = '',
  functions
}) => /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("section", {
  "data-testid": "ebds-key-functions",
  className: "ebds-key-functions"
}, /*#__PURE__*/React.createElement("div", {
  "data-testid": "ebds-key-functions-headlines",
  className: "ebds-key-functions__headlines"
}, subheadline && /*#__PURE__*/React.createElement("h2", {
  className: "ebds-h5"
}, subheadline), /*#__PURE__*/React.createElement("h3", null, headline), description && /*#__PURE__*/React.createElement("p", null, description)), imgUrl && /*#__PURE__*/React.createElement("div", {
  "data-testid": "ebds-key-functions-image",
  className: "ebds-key-functions__image"
}, /*#__PURE__*/React.createElement("img", {
  src: imgUrl,
  alt: imgAlt
})), /*#__PURE__*/React.createElement("div", {
  "data-testid": "ebds-key-functions-list",
  className: "ebds-key-functions__list"
}, functions?.map((v, i) => /*#__PURE__*/React.createElement(ComponentKeyFunction, Object.assign({
  key: i
}, v))))));
export default KeyFunctions;